"use client";

import React, { useEffect, useState } from "react";
import { detailsNav } from "@/data/packageDetailsNav";
import Overview from "./Overview";
// import Accomodation from "./Accomodation";
import Inclusions from "./Inclusions";
import { Itenary } from "./Itenary";
import CancellationPolicy from "./CancellationPolicy";
import { IPackageDetailsData } from "../interface/IPackageDetails.interface";
import OverviewFooter from "./OverviewFooter";
import Accomodation from "./Accomodation";

interface IProps {
  packageData?: IPackageDetailsData;
}
const PackageOverview: React.FC<IProps> = ({ packageData }) => {
  const [activeSection, setActiveSection] = useState<string>("overview");
  const itinerary = packageData?.itinerary ?? [];
  const activities = packageData?.activity ?? [];
  const meals = packageData?.meals ?? [];
  const accommodations = packageData?.accommodations ?? [];
  const inclusions = packageData?.inclusions ?? [];
  const exclusions = packageData?.exclusions ?? [];
  const currentPrice = packageData?.current_price ?? "0";

  useEffect(() => {
    const sectionElements = detailsNav
      .map((item) => document.getElementById(item.href.replace("#", "")))
      .filter(Boolean) as HTMLElement[];

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.4 }
    );

    sectionElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
  return (
    <>
      <div className="rounded-2xl shadow-[0_0_18px_0_#0000000A] pb-6 typography-mid-body-regular text-grey-700">
        {/* Sticky Nav */}
        <div className="bg-green-100 rounded-t-2xl sticky top-[60px] md:top-[104px] lg:top-20 z-30 overflow-x-auto overflow-y-hidden scrollbar-hide border-b border-green-200">
          <nav className="whitespace-nowrap px-2">
            {detailsNav.map((item) => {
              const sectionId = item.href.replace("#", "");
              const isActive = activeSection === sectionId;
              return (
                <a
                  key={item.href}
                  href={item.href}
                  className={`typography-extra-large-body-light font-normal px-6 sm:px-9 py-3 inline-block rounded-t-2xl transition-colors duration-300 ${
                    isActive ? "text-yellow-500" : "text-grey-700"
                  }`}
                >
                  {item?.label}
                </a>
              );
            })}
          </nav>
        </div>

        {/* Sections */}
        <div id="overview" className="scroll-mt-32">
          <Overview overview={itinerary} />
        </div>

        <div id="itenary" className="scroll-mt-32">
          <Itenary itinerary={itinerary} activity={activities} meals={meals} />
        </div>

        <div id="accommodation" className="scroll-mt-32">
          <Accomodation accomodation={accommodations} />
        </div>

        <div id="inclusions" className="scroll-mt-32">
          <Inclusions inclusions={inclusions} exclusions={exclusions} />
        </div>

        <div id="cancellationPolicy" className="scroll-mt-32">
          <CancellationPolicy
            paymentPolicy={packageData?.payment_policy}
            cancellationPolicy={packageData?.cancellation_policy}
            termsAndConditions={packageData?.terms_conditions}
          />
        </div>

        {/* Bottom Bar */}
      </div>

      <OverviewFooter price={currentPrice} />
    </>
  );
};

export default PackageOverview;
